<script lang="ts" setup>
import { defineProps, computed } from "vue";

const props = defineProps({
  maxAmount: {
    type: Number,
    required: true,
  },
  currentAmount: {
    type: Number,
    required: true,
  },
});

const progressPercentage = computed(() => {
  return Math.min(100, (props.currentAmount / props.maxAmount) * 100);
});
</script>

<template>
  <div class="progress-container">
    <div
      class="progress-bar"
      :style="{ width: progressPercentage + '%' }"
    ></div>
  </div>
</template>

<style scoped lang="scss">
@import "@/assets/style/colors";

.progress-container {
  width: 100%;
  height: 8px;
  background-color: var(--color-grey-blue);
  border-radius: 10px;
  overflow: hidden;
}

.progress-bar {
  height: 100%;
  background-color: var(--color-tertiary);
  border-radius: 10px;
  transition: width 0.3s ease;
}
</style>
